module.exports = __webpack_public_path__ + "img/79800.8774b86c.jpg";